import * as React from "react";

import { cn } from "@/lib/chillnn/cn";

import ArrowRightIcon from "../../icon/arrow-right";

type SelectScrollButtonProps = {
	direction: "up" | "down";
	onClick: () => void;
	className?: string;
};

const SelectScrollButton = React.forwardRef<HTMLButtonElement, SelectScrollButtonProps>(
	({ direction, onClick, className }, ref) => {
		const handleKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>) => {
			if (event.key !== "Enter" && event.key !== " ") return;
			event.preventDefault();
			onClick();
		};

		return (
			<button
				ref={ref}
				type="button"
				className={cn(
					"flex h-8 w-full cursor-pointer items-center justify-center rounded border border-transparent px-2 py-1 hover:bg-zinc-100 focus:outline-none focus-visible:border-zinc-950 active:border-zinc-950 data-[state=hidden]:pointer-events-none data-[state=hidden]:invisible data-[state=hidden]:opacity-0",
					className,
				)}
				onClick={onClick}
				onKeyDown={handleKeyDown}
				tabIndex={0}
				aria-label={direction === "up" ? "上にスクロール" : "下にスクロール"}
			>
				<ArrowRightIcon className={cn("h-4 w-4 opacity-50", direction === "up" ? "-rotate-90" : "rotate-90")} />
			</button>
		);
	},
);
SelectScrollButton.displayName = "SelectScrollButton";

export { SelectScrollButton };
